import * as React from 'react'
import './styles.css'
import TrademarkText from '../TrademarkText'

const PlatformRibbon = ({ className = '' }) => {
  const ribbonGroup = (
    <>
      <span className='platform-ribbon-label'>The Pod Intelligence Platform</span>
      <span className='platform-ribbon-divider' aria-hidden='true'>
        |
      </span>
      <span className='platform-ribbon-modules'>
        <span className='platform-ribbon-module-item'>
          <TrademarkText>Pod Intelligence Core™</TrademarkText>
        </span>
        <span className='platform-ribbon-module-separator' aria-hidden='true'>
          |
        </span>
        <span className='platform-ribbon-module-item'>
          <TrademarkText>Pod Atlas™</TrademarkText>
        </span>
        <span className='platform-ribbon-module-separator' aria-hidden='true'>
          |
        </span>
        <span className='platform-ribbon-module-item'>
          <TrademarkText>Pod Matching Engine™</TrademarkText>
        </span>
        <span className='platform-ribbon-module-separator' aria-hidden='true'>
          |
        </span>
        <span className='platform-ribbon-module-item'>
          <TrademarkText>Pod Adaptive Intelligence Engine™</TrademarkText>
        </span>
      </span>
    </>
  )

  return (
    <div className={`platform-ribbon ${className}`.trim()}>
      <div className='platform-ribbon-inner'>
        <div className='platform-ribbon-track'>
          <div className='platform-ribbon-group'>{ribbonGroup}</div>
          <div className='platform-ribbon-group' aria-hidden='true'>
            {ribbonGroup}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PlatformRibbon
